import React, { Component } from 'react';
import { Provider, observer } from 'mobx-react';
import { configure } from 'mobx';
import rootStore from "./stores/rootStore";
import SectionsTreeApp from  './components/SectionsTreeApp'
import { StoreContext } from "./stores/contexts";

configure({
    enforceActions: "never",
    isolateGlobalState: true
});

/*
let _rootStore=null;
const App=(props)=>{
  if(!_rootStore) {
    _rootStore=new rootStore(props.initial);
  }
  return (
    <div className="h100" ref={(ref)=>{ _rootStore.root_element=ref; }}>
      <StoreContext.Provider value={_rootStore.getStores()}>
        <SectionsTreeApp />
      </StoreContext.Provider>
    </div>
  );
};
export default App;
*/

class App extends Component {
  constructor(props) {
    super(props);
    this._rootStore=new rootStore(props.initial);
    if(props.initial.communicatorRef) {
      props.initial.communicatorRef(this._rootStore.communicatorStore);
    }
  }
  render() {
    return (
      <div className="h100 pr" ref={(ref)=>{ this._rootStore.root_element=ref; }}>
        <StoreContext.Provider value={this._rootStore.getStores()}>
          <SectionsTreeApp disable_controlls={this.props.disable_controlls} />
        </StoreContext.Provider>
      </div>
    );
  }
}

export default App;
